<template>
    <div>
        <h3>{{ (template.name) ? 'Template Settings' : 'Create A New Template' }}</h3>
        <form class="large-form">
            <div class="form-line">
                <div class="form-field" id="form-field-name" style="width: 100%;">
                    <label for="form-input-name">Template Name</label>
                    <input id="form-input-name" type="text" v-model="model.name" required>
                    <div class="field-note">Template names will be visible to all users in the template gallery.</div>
                </div>
            </div>
            <!--
            <div class="form-line">
                <div class="form-field">
                    <label>Image</label>
                    <media-gallery-selector v-model="model.image"/>
                </div>
            </div>
            -->
            <div class="form-line">
                <div class="form-field" id="form-field-select">
                    <label for="form-input-type">Template Type</label>
                    <WSSelect v-model="model.category" :options="surveyTypes" />
                    <div class="field-note">For template listing page filter.</div>
                </div>
            </div>
            <div class="form-line">
                <div class="form-field" id="form-field-text">
                    <label for="form-input-type">Template Description</label>
                    <textarea v-model="model.description" rows="4"></textarea>
                    <div class="field-note">Please provide a brief template description for the template catalogue.</div>
                </div>
            </div>
            <div class="form-line" v-if="template.name">
                <div class="form-field" id="form-field-page-type">
                    <label for="form-input-page-type">Status</label>
                    <WSSelect v-model="model.status" :options="[
                        {value: 'draft', text: 'Draft'},
                        {value: 'active', text: 'Active'},
                    ]" />
                </div>
            </div>
            <div v-if="template.id" style="text-align: right">
                <div class="ws-button ws-button-negative small" @click="onDelete">Delete Template</div>
            </div>
        </form>
        <div class="form-actions">
            <div class="ws-button ws-button-secondary" @click="onCancel">Cancel</div>
            <div class="ws-button ws-button-main" @click="onSubmit">{{ (template.name) ? 'Save Changes' : 'Create A New Template' }}</div>
        </div>
    </div>
</template>

<script>
import { snakeCase } from "lodash-es";
import MediaGallerySelector from "@/components/MediaGallerySelector";
import WSSelect from "@/components/elements/WSSelect.vue";

export default {
    name: 'TemplateSettingsForm',
    components: {WSSelect, MediaGallerySelector},
    props: {
        template: {
            type: Object,
            default: () => ({
                name: undefined,
                category: undefined,
                slug: undefined,
                description: undefined,
                image: undefined,
                status: 'draft',
            })
        },
    },
    data() {
        return {
            model: {
                name: undefined,
                category: undefined,
                slug: undefined,
                description: undefined,
                image: undefined,
                status: 'draft',
            }
        }
    },
    created() {
        this.resetModel();
    },
    methods: {
        generateSlug() {
            if (!this.model.slug) {
                this.model.slug = snakeCase(this.model.name).replaceAll('_', '-')
            }
        },
        onSubmit() {
            this.model.createWelcomePage = true;
            this.$emit('save', {...this.model})
        },
        resetModel() {
            this.model = {...this.template}
        },
        onCancel() {
            this.$emit('cancel')
        },
        onDelete() {
            if (confirm('Are you sure you want to delete this template?')) {
                this.$store.dispatch('surveyTemplates/delete', this.template.id)
                this.$router.push({path: '/surveys/templates'})
            }
        }
    },
    computed: {
        surveyTypes() {
            return this.$store.state.surveyTypes;
        }
    }
}
</script>
